<div class="or-d-flex or-justify-content-center or-mx-20-px">
  <button
    type="button"
    class="tabs__pill or-d-flex or-align-items-center or-justify-content-center or-px-16-px or-py-8-px or-head-xs or-cursor-pointer or-h-36-px or-mr-8-px"
    [class.button-primary-style]="source() === MyGamesSource.ALL"
    [class.button-secondary-style]="source() !== MyGamesSource.ALL"
    (click)="select(MyGamesSource.ALL)">
    Wszystkie
  </button>
  <button
    type="button"
    class="tabs__pill or-d-flex or-align-items-center or-justify-content-center or-px-16-px or-py-8-px or-head-xs or-cursor-pointer or-h-36-px or-mr-8-px"
    [class.button-primary-style]="source() === MyGamesSource.HOSTED"
    [class.button-secondary-style]="source() !== MyGamesSource.HOSTED"
    (click)="select(MyGamesSource.HOSTED)">
    Organizator
  </button>
  <button
    type="button"
    class="tabs__pill or-d-flex or-align-items-center or-justify-content-center or-px-16-px or-py-8-px or-head-xs or-cursor-pointer or-h-36-px"
    [class.button-primary-style]="source() === MyGamesSource.PLAYER"
    [class.button-secondary-style]="source() !== MyGamesSource.PLAYER"
    (click)="select(MyGamesSource.PLAYER)">
    Gracz
  </button>
</div>
